export const mockAddressRules = {
    "fields": [
        {
            "colSpan": 24,
            "formatPattern": "",
            "inputType": "dropdown",
            "instructions": "",
            "key": "countryText",
            "keyboardType": "",
            "labelTitle": "Country",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": []
        },
        {
            "colSpan": 12,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "",
            "key": "firstName",
            "keyboardType": "",
            "labelTitle": "First Name",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "First name is required."
                },
                {
                    "checkRegex": "^.{1,32}$",
                    "error": "First name should be 1-32 letters or spaces."
                }
            ]
        },
        {
            "colSpan": 12,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "",
            "key": "lastName",
            "keyboardType": "",
            "labelTitle": "Last Name",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "Last name is required."
                },
                {
                    "checkRegex": "^.{1,32}$",
                    "error": "Last name should be 1-32 letters or spaces."
                }
            ]
        },
        {
            "colSpan": 24,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "Your phone number may be shared with the delivery company only for order fulfillment and delivery notifications.",
            "key": "mobile",
            "keyboardType": "number",
            "labelTitle": "Phone Number",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [
                "+1"
            ],
            "placeholder": "",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "Phone number is required."
                },
                {
                    "checkRegex": "^\\d{10}$",
                    "error": "Phone number should be a 10-digit number."
                }
            ]
        },
        {
            "colSpan": 24,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "",
            "key": "address1",
            "keyboardType": "",
            "labelTitle": "Address Line 1",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "Street name and street number, company.",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "Address Line 1 is required."
                },
                {
                    "checkRegex": "^.{0,50}$",
                    "error": "Address Line 1 cannot exceed 50 characters."
                },
                {
                    "checkRegex": "^.{5,}$",
                    "error": "Address Line 1 should contain at least 5 characters."
                }
            ]
        },
        {
            "colSpan": 24,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "",
            "key": "address2",
            "keyboardType": "",
            "labelTitle": "Address Line 2",
            "maxlength": 0,
            "optional": true,
            "phonePrefixes": [],
            "placeholder": "Apt, unit, building, floor, room, etc. (optional)",
            "validation": [
                {
                    "checkRegex": "^.{0,50}$",
                    "error": "Address Line 2 cannot exceed 50 characters."
                }
            ]
        },
        {
            "colSpan": 12,
            "formatPattern": "",
            "inputType": "dropdown",
            "instructions": "",
            "key": "provinceText",
            "keyboardType": "",
            "labelTitle": "State / Province",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "State / Province is required."
                }
            ]
        },
        {
            "colSpan": 12,
            "formatPattern": "",
            "inputType": "dropdown",
            "instructions": "",
            "key": "cityText",
            "keyboardType": "",
            "labelTitle": "City",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": [
                {
                    "checkRegex": "^(?!\\s*$).+",
                    "error": "City is required."
                }
            ]
        },
        {
            "colSpan": 24,
            "formatPattern": "",
            "inputType": "text",
            "instructions": "",
            "key": "zipcode",
            "keyboardType": "",
            "labelTitle": "ZIP / Post Code",
            "maxlength": 0,
            "optional": false,
            "phonePrefixes": [],
            "placeholder": "",
            "validation": []
        }
    ]
}